"use client"

import { createBrowserClient } from "@supabase/ssr"
import { SUPABASE_AUTH_COOKIE_OPTIONS } from "./authCookieOptions"
import type { Database } from "./types"

let _authClient: ReturnType<typeof createBrowserClient<Database>> | null = null

// LA instancia browser de Supabase — auth Y datos (cookie-based). SESS-13:
// históricamente había DOS createBrowserClient (este + lib/supabase/client.ts),
// cada uno con su propio timer de auto-refresh sobre el MISMO refresh token
// rotativo, y el listener que persiste la sesión nativa (sessionStore) solo
// escuchaba a este. Cuando el otro cliente rotaba el token, el blob de rescate
// quedaba stale → al siguiente cold launch (WebView suelta la cookie) el
// rehydrate moría con 4xx definitivo y la tablet aterrizaba en login. Una sola
// instancia = un solo refresher = el listener ve TODAS las rotaciones.
// getSupabaseClient() (client.ts) delega aquí; no crear más instancias.
export function getAuthClient() {
  if (!_authClient) {
    _authClient = createBrowserClient<Database>(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      {
        cookieOptions: SUPABASE_AUTH_COOKIE_OPTIONS,
        realtime: {
          params: { eventsPerSecond: 10 },
        },
      }
    )
  }
  return _authClient
}
